<template>
  <div class="header" id="header">
    <div class="header-container" ref="header">
      <div class="header-icon">
        <img
          class="header-icon-img cs"
          src="../assets/images/logo.svg"
          @click="didClick_re"
        />
        <img
          class="header-toggle-img"
          :src="navbarOpen ? collapseCloseImg : collapseImg"
          alt=""
          @click="navbarOpen = !navbarOpen"
        />
      </div>
      <div
        class="navbar-header"
        :class="{ open: navbarOpen, 'sub-open': navbarOpen && openIndex }"
      >
        <ul class="nav header-tabs">
          <li
            v-if="isLiveTime"
            :class="{ active: tabIndex == 10 }"
            @click="didClick_tab('live', 10, '首页')"
          >
            <div class="label">
              <img src="../assets/images/live-icon.png" />直播
            </div>
          </li>
          <li
            v-show="true"
            :class="{ active: tabIndex == 1 }"
            @click="didClick_tab('agenda', 1, '大会议程')"
          >
            <div class="label">大会议程</div>
          </li>
          <li
            v-show="false"
            :class="{ active: tabIndex == 2 }"
            @click="didClick_tab('parallelSessions', 2, '分会场联动')"
          >
            <div class="label">区域活动</div>
          </li>
          <li
            :class="{
              active: tabIndex == 3 || tabIndex == 4,
              open: openIndex == 1,
            }"
          >
            <div class="navbar-top" @click="clickSub(1)">
              <div class="label">开发者</div>
              <img class="arrow" src="../assets/images/arrow.png" alt="" />
            </div>
            <div class="sub-navbar">
              <ul>
                <li
                  :class="[
                    tabIndex == 3 ? 'active-child-hove' : 'active-child',
                  ]"
                  @click="didClick_tab('developer', 3, '开发者社区')"
                >
                  开发者社区
                </li>
                <li
                  :class="[
                    tabIndex == 4 ? 'active-child-hove' : 'active-child',
                  ]"
                  @click="didClick_tab('sandbox', 4, '沙箱实验室')"
                >
                  沙箱实验室
                </li>
              </ul>
            </div>
          </li>

          <li
            v-show="true"
            :class="{ active: tabIndex == 1 }"
            @click="didClick_tab('partner', 7, '合作伙伴')"
          >
            <div class="label">合作伙伴</div>
          </li>
          <li
            v-if="!putType"
            :class="{
              active: tabIndex == 5 || tabIndex == 6,
              open: openIndex == 2,
            }"
          >
            <div class="navbar-top" @click="clickSub(2)">
              <div class="label">媒体中心</div>
              <img class="arrow" src="../assets/images/arrow.png" alt="" />
            </div>
            <div class="sub-navbar">
              <div class="sub-navbar-block"></div>
              <ul>
                <li
                  :class="[
                    tabIndex == 5 ? 'active-child-hove' : 'active-child',
                  ]"
                  @click="didClick_tab('news', 5, '热门资讯')"
                >
                  热门资讯
                </li>
                <li
                  :class="[
                    tabIndex == 6 ? 'active-child-hove' : 'active-child',
                  ]"
                  @click="didClick_tab('videos', 6, '精彩视频')"
                >
                  精彩视频
                </li>
              </ul>
            </div>
          </li>
          <!-- <li
            @click="
              isLogin && AttendanceStatus != 3
                ? didClick_Personal()
                : didClick_login()
            "
          >
            <img class="header-back-img" :src="userImgUrl" />
            <div class="label cs">
              {{
                isLogin && AttendanceStatus != 3 ? "个人中心" : "报名线上参会"
              }}
            </div>
          </li> -->
          <li v-if="isLogin" @click="didClick_signOut">
            <div class="label cs">退出登录</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="popup flex align-center justify-center" v-if="showPop">
      <div id="pop-wap" class="box">
        <img
          @click="closePop"
          class="close-img"
          src="@/assets/images/wap/popup/close.png"
        />
        <img class="bg-img" src="@/assets/images/wap/popup/bg.png" />
        <div class="contact">您未报名，报名后有助于您使用更多功能</div>
        <div
          class="confirmBtn flex align-center justify-center"
          @click="goRegister"
        >
          去报名
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { $config } from "../conf";
import _ from "lodash";
import store from "../store";
import addEventListener from "ant-design-vue/lib/vc-util/Dom/addEventListener";
import { set } from "lodash/object";
import Cookie from "js-cookie";

export default {
  name: "Header",
  props: {
    //当前日期index
    dateIndex: {
      type: Number,
      default: 0,
    },
    //当前类型index
    tabIndex1: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    dateIndex: function (newVal, oldVal) {
      this.thisDateIndex = newVal;
    },
    tabIndex1: function (newVal, oldVal) {
      this.thisTabIndex = newVal;
    },
  },
  computed: mapState({
    nowTime: (state) => state.nowTime,
    userInfo: (state) => state.userInfo.info,
    tokenInfo: (state) => state.userInfo.token,
    isLogin: (state) => !!state.userInfo.token,
    AttendanceStatus: (state) => state.userInfo.AttendanceStatus,
  }),
  data() {
    return {
      isLiveTime: false,
      collapseImg: require("../assets/images/collapse.png"),
      collapseCloseImg: require("../assets/images/collapse-close.png"),
      userImgUrl: require("../assets/images/header/user.png"),
      tabIndex: -1,
      openIndex: null,
      isDeveloper: false, //鼠标划过开发者 选项
      isMedia: false, //鼠标划过媒体 选项
      globalUserIdData: "",
      navbarOpen: false,
      isIE: window.navigator.userAgent.indexOf("MSIE") >= 1,
      headerDark: false, //header 背景变深
      showPop: false,
      headerHeight: 60,
      thisDateIndex: 0,
      thisTabIndex: 0,
      allowSign: true,
      putType: false,
    };
  },
  mounted() {
    this.isLiveTime = this.nowTime > new Date("2022/06/14 22:00:00");
    if (this.$store.state.isMobile) {
      this.$bus.$on("closeMenu", () => {
        this.navbarOpen = false;
      });
    }

    this.putType = !!(this.$route.query.putType || Cookie.get("putType"));
    this.$nextTick(() => {
      this.headerHeight = this.$refs["header"].offsetHeight;
    });

    if (this.$store.state.isAndroid) {
      addEventListener(
        document.body,
        "scroll",
        _.debounce(() => {
          const top = this.getOffsetTop(
            document.getElementById("header"),
            document.body
          );
          this.headerDark = -top > 100;
        })
      );
      if (this.$route.path == "/") {
        window.addEventListener(
          "scroll",
          _.debounce(
            () => {
              this.onScroll();
              //如果是wap端 关闭长在打开的header
              if (this.$store.state.isMobile) {
                this.navbarOpen = false;
              }
              //header 滚动 超过 100px header背景颜色 变深
              let scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
              this.headerDark = scrollTop > 100;
              if (document.getElementsByClassName("home-container")[0]) {
                scrollTop = this.$store.state.isAndroid
                  ? document.getElementsByClassName("home-container")[0]
                      .scrollTop
                  : 0;
              }
              this.headerDark = scrollTop > 100;
            },
            1,
            false
          ),
          true
        );
      }
    } else {
      // 监听滚动事件
      window.addEventListener(
        "scroll",
        _.debounce(
          () => {
            this.onScroll();
            //如果是wap端 关闭长在打开的header
            if (this.$store.state.isMobile) {
              this.navbarOpen = false;
            }
            //header 滚动 超过 100px header背景颜色 变深
            let scrollTop =
              document.documentElement.scrollTop || document.body.scrollTop;
            this.headerDark = scrollTop > 100;
          },
          1,
          false
        ),
        true
      );
    }
    //监听不是 home跳页到 home
    if (this.$route.params.id) {
      setTimeout(() => {
        this.didClick_tab(
          this.$route.params.id,
          this.$route.params.idx,
          this.$route.params.ch
        );
      }, 500);
    }
    this.thisDateIndex = this.dateIndex;
    this.thisTabIndex = this.tabIndex1;
    // //二级页面 导航变红
    // if (this.$route.name !== "/") {
    //   switch (this.$route.name) {
    //     case "news":
    //       this.tabIndex = 5;
    //       break;
    //     case "videos":
    //       this.tabIndex = 6;
    //       break;
    //   }
    // }
    //微吼直播间的导航有一个合作伙伴，我们需要给一个带锚点定位的链接，点击到首页的合作伙伴位置
    if (this.$route.query && this.$route.query.isLinkToPartner == "1") {
      this.$nextTick(() => {
        setTimeout(() => {
          this.didClick_tab("partner", 7, "合作伙伴");
        }, 200);
      });
    }
    this.$bus.$on("ready", (e) => {
      setTimeout(() => {
        if (this.$route.query && this.$route.query.isLinkToPartner == "1") {
          this.didClick_tab("partner", 7, "合作伙伴");
        }
      }, 200);
    });
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener("scroll", this.onScroll);
    if (this.$store.state.isAndroid) {
      this.$bus.$off("headerDark");
    }
  },
  methods: {
    getOffsetTop: function (element, container) {
      if (!element) {
        return 0;
      }

      if (!element.getClientRects().length) {
        return 0;
      }

      var rect = element.getBoundingClientRect();

      if (rect.width || rect.height) {
        if (container === window) {
          container = document.body;
          return rect.top - container.clientTop;
        }
        return rect.top - container.getBoundingClientRect().top;
      }

      return rect.top;
    },
    //返回上一页
    didClick_re() {
      let channel = Cookie.get("channel");
      window.location.href =
        $config.homePage +
        (!channel || channel === "undefined"
          ? ""
          : `?channel=${channel || ""}`);
    },
    clickSub(idx) {
      this.openIndex = this.openIndex === idx ? null : idx;
    },
    //点击顶部 tabs
    didClick_tab(type, idx, ch) {
      //若是参会指南 直接去 参会指南二级页面
      if (type === "guide") {
        //埋码
        window._hw("send", "action", "index_meeting_guide_click");
        this.$router.push({
          path: "/guide",
        });
        return;
      }
      // debugger
      this.tabIndex = idx;
      this.navbarOpen = false;
      //若当前不是 home页 点击 顶部，返回home页，锚点组件监听，跳到指定位置
      if (this.$route.path !== "/") {
        if (type == "live") {
          this.$router.push({
            path: "/",
          });
          return;
        }
        if (type == "parallelSessions") {
          this.$router.push({
            path: "/cityTravel",
          });
          return;
        }
        if (
          type == "developer" ||
          type == "sandbox" ||
          //type == "live" ||
          type == "introduce" ||
          type == "partner" //||
          //type == "parallelSessions"
        ) {
          this.$router.push({
            name: "home",
            params: { id: type, idx: idx, ch },
          });
        } else {
          this.$router.push({
            name: type,
            params: {},
          });
        }
        return;
      } else {
        if (type.type) {
          if (this.$store.state.isMobile) {
            if (this.$store.state.isAndroid) {
              let targetbox = `document.getElementById(type.id)`;
              this.ScrollTop(targetbox.offsetTop, 500, type.id);
            } else {
              let targetbox = document.getElementById(type.id);
              this.ScrollTop(targetbox.offsetTop + 210, 500, type.id);
            }
          } else {
            let targetbox = document.getElementById(type.id);
            this.ScrollTop(targetbox.offsetTop - 40, 500, type.id);
          }
        } else {
          if (this.$store.state.isMobile) {
            this.openIndex = null;
            let targetbox = document.getElementById(type);
            this.ScrollTop(targetbox.offsetTop, 500, type);
          } else {
            this.openIndex = null;
            let targetbox = document.getElementById(type);
            this.ScrollTop(targetbox.offsetTop - 60, 500, type);
          }
        }
      }
      window._hw("send", "action", "index_top_menu_btn_click", {
        top_menu_btn_name: ch,
      });
    },
    //点击登录报名
    didClick_login() {
      window._hw("send", "action", "index_top_menu_btn_click", {
        top_menu_btn_name: "报名线上参会",
      });
      let channel = Cookie.get("channel");
      let nowUrl =
        `${window.location.origin + window.location.pathname}` +
        `?channel=${channel || ""}&dateIndex=${this.thisDateIndex}&tabIndex=${
          this.thisTabIndex
        }`;
      if (this.isLogin) {
        const { signUpOfflineUrl, signOnlineUrl } = $config;
        //已登录 由于无线下报名  故跳线上报名表signOnlineUrl
        window.location.href = `${signOnlineUrl}?channel=${
          channel || ""
        }&returnUrl=${encodeURIComponent(nowUrl)}`;
      } else {
        this.goRegister();
      }
    },
    //退出登录
    didClick_signOut() {
      window._hw("send", "action", "index_top_menu_btn_click", {
        top_menu_btn_name: "退出登录",
      });
      if (this.$route.path == "/personal") {
        window.location = this.$config.homePage;
      }
      this.$store.dispatch("userInfo/logout");
    },
    //点击个人中心
    didClick_Personal() {
      window._hw("send", "action", "index_top_menu_btn_click", {
        top_menu_btn_name: "个人中心",
      });
      if (this.AttendanceStatus == 3) {
        this.showPop = true;
      } else {
        this.$router.push({
          path: "/personal",
          query: {},
        });
      }
    },
    closePop() {
      this.showPop = false;
    },
    goRegister() {
      const smarketToken = this.tokenInfo.smarketToken || "";
      let nowUrl =
        `${window.location.origin + window.location.pathname}` +
        `?dateIndex=${this.thisDateIndex}&tabIndex=${this.thisTabIndex}`;
      let channel = Cookie.get("channel");
      if (smarketToken) {
        const { signUpOfflineUrl } = $config;
        const { signUpOnlineUrl } = $config;
        if (this.$store.state.userInfo.AttendanceStatus != 1) {
          window.location.href = `${signUpOnlineUrl}?channel=${
            channel || ""
          }&returnUrl=${encodeURIComponent(nowUrl)}`;
        } else {
          window.location.href = `${signUpOfflineUrl}?channel=${
            channel || ""
          }&returnUrl=${encodeURIComponent(nowUrl)}`;
        }
      } else {
        const { signOnlineUrl } = $config;
        window.location.href = `${signOnlineUrl}?channel=${
          channel || ""
        }&returnUrl=${encodeURIComponent(nowUrl + "&isLoginReturn=1")}`;
      }
    },
    heightToTop(ele) {
      //ele为指定跳转到该位置的DOM节点
      let root = document.body;
      let height = 0;
      do {
        height += ele.offsetTop;
        ele = ele.offsetParent;
      } while (ele !== root);
      return height;
    },
    ScrollTop(number, time, type) {
      if (
        this.$store.state.isAndroid &&
        document.getElementsByClassName("home-container")[0]
      ) {
        //如果是android
        document.getElementsByClassName("home-container")[0].scrollTop = number;
      } else {
        document.body.scrollTop = document.documentElement.scrollTop = number;
      }
      // if (!time) {
      //   document.body.scrollTop = document.documentElement.scrollTop = number;
      //   return number;
      // }
      // const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
      // let spacingInex = 25; // 计算循环的次数
      // let nowTop = document.body.scrollTop + document.documentElement.scrollTop; // 获取当前滚动条位置
      // let everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
      // let scrollTimer = setInterval(() => {
      //   if (spacingInex > 0) {
      //     spacingInex--;
      //     this.ScrollTop((nowTop += everTop));
      //   } else {
      //     clearInterval(scrollTimer); // 清除计时器
      //     var u = navigator.userAgent;
      //     var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      //     if (isAndroid) {
      //       document.getElementById(type).scrollIntoView({
      //         behavior: "smooth",
      //         block: "start",
      //         inline: "nearest",
      //       });
      //     }
      //   }
      // }, spacingTime);
    },
    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll(
        ".home-container .page-box"
      );
      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop - 70);
      });

      // 获取当前文档流的 scrollTop
      // const scrollTop =
      //   document.documentElement.scrollTop || document.body.scrollTop;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (
        this.$store.state.isAndroid &&
        document.getElementsByClassName("home-container")[0]
      ) {
        scrollTop = this.$store.state.isAndroid
          ? document.getElementsByClassName("home-container")[0].scrollTop
          : 0;
      }
      //header 滚动 超过 100px header背景颜色 变深
      // this.headerDark = scrollTop > 100;
      // 定义当前点亮的导航下标
      let navIndex = -1;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是 n 了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n;
        }
      }
      // 把下标赋值给 vue 的 data
      this.tabIndex = navIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
//header begin
.header {
  font-size: 14px;

  .header-container {
    position: relative;
    //position: fixed;
    //top: 0;
    //left: 0;
    width: 100%;
    box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2);
    background-color: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(5px);
    z-index: $z-index-header;
    padding: 0 210px;
  }

  .header-icon {
    float: left;
    height: 66px;
    display: flex;
    align-items: center;

    .header-icon-img {
      width: 122px;
      object-fit: cover;
    }

    .header-toggle-img {
      display: none;
      //position: relative;
      //float: right;
      width: 38px;
      height: 38px;
      //object-fit: cover;
      //cursor: pointer;
    }
  }

  .navbar-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 66px;
  }

  .nav {
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
  }

  .header-tabs {
    height: auto;
    font-size: 20px;
    color: #000000;
    line-height: 24px;
    display: flex;
    flex-direction: row;

    & > li {
      padding: 0 30px;
      height: auto;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .arrow {
        display: none;
      }

      img {
        width: 17px;
        height: 18px;
        margin-right: 12px;
      }

      .sub-navbar {
        display: none;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 140px;
        padding: 50px 0 20px 0;
        z-index: 0;

        &:hover {
          display: block;
        }

        .sub-navbar-block {
          width: 100%;
          height: 0px;
        }
      }

      &:hover {
        .sub-navbar {
          display: block;
        }
      }

      ul {
        margin-top: -10px;
        padding: 10px 0 10px 0;
        flex-direction: column;
        align-items: center;
        list-style: none;
        border: 1px solid;
        border-image: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 1)
          )
          1 1;
        background-color: #f1f4fa;
        backdrop-filter: blur(5px);
        text-align: center;

        li {
          cursor: pointer;
        }

        li + li {
          margin-top: 10px;
        }
      }
    }

    .active {
      //color: #b4251e;
    }

    .active-child {
      color: #000000;
    }

    .active-child-hover {
      //color: #b4251e;
    }
  }

  .header-tabs + .header-tabs {
    border-left: 1px solid #ccc;
    margin-left: 10px;
    padding-left: 10px;
  }
}

.popup {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0 0 0 0;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: $z-index-header;

  .box {
    width: 450px;
    height: 214px;
    background: #ffffff;
    border: 1px solid #666666;
    position: relative;

    .close-img {
      width: 14px;
      height: 14px;
      position: absolute;
      right: 26px;
      top: 23px;
      z-index: 2;
      cursor: pointer;
    }

    .bg-img {
      width: 166px;
      height: 111px;
      position: absolute;
      left: 0;
      bottom: 0;
    }

    .contact {
      height: 28px;
      font-size: 18px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #333333;
      line-height: 25px;
      margin-top: 65px;
      text-align: center;
    }

    .confirmBtn {
      margin: 26px auto 0 auto;
      width: 170px;
      height: 40px;
      background: #b4251e;
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;

      color: #ffffff;
      line-height: 24px;
      cursor: pointer;
    }
  }
}

.dark {
  background-color: rgba(255, 255, 255, 1);
}

//header end
@media (max-width: 992px) {
  .header {
    //height: 114px;
    .header-container {
      padding: 0 36px;
    }

    &:before {
      height: 114px;
    }

    .header-container {
      width: 100%;
      padding: 0 36px;

      .header-icon {
        float: initial;
        height: 114px;
        justify-content: space-between;

        .header-icon-img {
          width: 180px;
        }

        .header-toggle-img {
          display: block;
        }
      }

      .navbar-header {
        position: absolute;
        top: 110px;
        left: 145px;
        right: 155px;
        justify-content: flex-start;
        flex-direction: column;
        margin: 0 -160px 0 -147px;
        height: 0px;
        box-shadow: 0px 10px 20px 1px rgba(0, 0, 0, 0.05);
        background-color: rgba(243, 247, 255, 0.9);
        backdrop-filter: blur(20px);
        overflow: hidden;
        transition-timing-function: ease;
        transition-duration: 0.35s;
        transition-property: height, visibility;

        &.open {
          height: auto;
          padding-bottom: 50px;
        }

        &.open.sub-open {
          height: 920px;
        }
      }

      .header-tabs {
        width: 100%;
        flex-direction: column;
        font-size: 28px;

        & > li {
          margin: 0 36px;
          justify-content: flex-start;
          border-bottom: 1px solid #dddddd;
          display: block;
          .navbar-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            img {
              position: relative;
              top: unset;
              margin-right: 12px;
            }
          }
          .label {
            height: 99px;
            line-height: 99px;
          }

          .arrow {
            display: block;
            position: absolute;
            top: 45px;
            right: 0;
            width: 24px;
            height: 40px;
            object-fit: contain;
          }

          img {
            display: none;
          }

          .sub-navbar {
            display: block;
            position: relative;
            width: 100%;
            height: 0px;
            padding: 0 0 0 47px;
            overflow: hidden;
            transition-timing-function: ease;
            transition-duration: 0.35s;
            transition-property: height, visibility;

            ul {
              background: transparent;
              backdrop-filter: initial;
              border: none;
              border-top: 1px solid #dddddd;
              padding: 30px 0 30px 10px;

              li {
                height: 70px;
                line-height: 70px;
                text-align: left;
              }
            }
          }

          &.open {
            .arrow {
              transform: rotate(180deg);
              transition: transform 0.35;
            }

            .sub-navbar {
              height: 209px;
            }
          }
        }
      }

      .header-tabs + .header-tabs {
        border: none;
        margin: 0;
        padding: 0;
      }
    }
  }

  .popup {
    .box {
      width: 600px;
      height: 300px;

      .close-img {
        width: 21px;
        height: 21px;
        top: 30px;
        right: 30px;
      }

      .bg-img {
        width: 249px;
        height: 167px;
      }

      .contact {
        font-size: 28px;
        margin-top: 100px;
      }

      .confirmBtn {
        margin-top: 40px;
        width: 255px;
        height: 60px;
        font-size: 24px;
      }
    }
  }
}

@media screen and (min-aspect-ratio: 84/90) and (max-aspect-ratio: 100/90) {
  .header {
    height: unset;

    .header-container {
      .header-icon {
        height: 60px;

        .header-icon-img {
          width: 100px;
        }

        .header-toggle-img {
          width: 20px;
          height: 20px;
        }
      }

      .navbar-header {
        top: 60px;
      }

      .header-tabs {
        width: 100%;
        flex-direction: column;
        font-size: 20px !important;

        & > li {
          .label {
            height: 60px;
            line-height: 60px;
          }
          .navbar-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            img {
              position: relative;
              top: unset;
              margin-right: 12px;
            }
          }

          .sub-navbar {
            ul {
              padding: 18px 0 18px 10px;

              li {
                height: 40px;
                line-height: 40px;
              }
            }
          }

          &.open {
            .sub-navbar {
              height: 120px;
            }
          }
        }
      }
    }
  }
}

@media (min-width: 992px) {
  .header {
    .header-container {
      font-size: 20px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 145px;
      background-color: #f1f4fa;
    }

    .header-icon {
      width: 170px;

      .header-icon-img {
        width: 170px;
        object-fit: cover;
      }
    }

    .navbar-header {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 90px;
    }
    .label {
      display: flex;
      align-items: center;
      img {
        margin-right: 10px;
        width: 12px;
      }
    }
  }
}
</style>
